export default {
  // 可能是通用的
  Chat_History: '歷史紀錄',
  History: '紀錄'
  // 独有
}
